module.exports = __webpack_public_path__ + "static/media/totalcoop-logo.532508e5.png";